import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { LottiePlayer } from '../../LottiePlayer/LottiePlayer';
import waitingExperienceAnimation from './waiting-experience.json';
import styles from './WaitingStep.module.scss';
export const GetWaitingStepTID = (parentTestId)=>getTestIds({
        parentTestId
    });
export const WaitingStep = (param)=>{
    let { testId, onComplete } = param;
    const testIds = useMemo(()=>GetWaitingStepTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsx(Box, {
        className: styles.root,
        testId: testIds.WaitingStepTestIds.Root(),
        children: /*#__PURE__*/ _jsx(LottiePlayer, {
            animationData: waitingExperienceAnimation,
            loop: false,
            autoplay: true,
            onComplete: onComplete,
            className: styles.lottie,
            testId: testIds.WaitingStepTestIds.LottiePlayer()
        })
    });
};
